import { reelsParams } from '../constants/reelConstants';
import { isMobile } from './isMobile';

export function mousePositionToIconColumnRow(element, mouseEvent) {
  const { tx, ty } = element.worldTransform;

  const inputPos = mouseEvent.data.getLocalPosition(element.parent);

  const {
    visibleRows,
    iconsFinalPositions: { inWinContainer },
    iconsHeight,
    iconsWidth,
  } = reelsParams[0];

  const visibleRowCenters = inWinContainer
    .slice(visibleRows, visibleRows + 4)
    .map(({ yInWin }) => yInWin);

  const columnPositions = reelsParams.map(({ finalPositionX }) => finalPositionX);

  const halfIconWidth = iconsWidth / 2;
  const halfIconHeight = iconsHeight / 2;

  const containerX = inputPos.x - (isMobile() ? 0 : tx);
  const containerY = inputPos.y + halfIconHeight - ty;

  const column = columnPositions.findIndex((xPos, index, arr) => {
    if (index < arr.length - 1) {
      return containerX >= xPos && containerX < arr[index + 1];
    }
    return containerX >= xPos && containerX < xPos + iconsWidth;
  });

  const row = visibleRowCenters.findIndex(
    (centerY) => containerY >= centerY - halfIconHeight && containerY <= centerY + halfIconHeight
  );

  return { column, row };
}
